import type { InjectionKey } from "vue";
import { z } from "zod";

export const AppEnv = z.object({
  VITE_API_URL: z.string().url(),
  VITE_LOG_LEVEL: z.enum(['TRACE', 'DEBUG', 'ERROR', 'INFO', 'SILENT', 'WARN'])
});

export type AppEnv = z.infer<typeof AppEnv>

export const ENVIRONMENT = Symbol() as InjectionKey<AppEnv>
